import { render } from "./UpdateMenuModifier.vue?vue&type=template&id=c4e34146&scoped=true"
import script from "./UpdateMenuModifier.vue?vue&type=script&lang=js"
export * from "./UpdateMenuModifier.vue?vue&type=script&lang=js"

import "./UpdateMenuModifier.vue?vue&type=style&index=0&id=c4e34146&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e34146"]])

export default __exports__